<ng-container *ngIf="crwVoucherData$ | async as crwVoucherData">
  <div
    *ngIf="crwVoucherData.crwSubCart.length > 0 && crwVoucherData.crwFlowSection === 'payment'"
    class="card">
    <form
      (click)="formClicked($event)"
      [formGroup]="formGroup"
      (ngSubmit)="onSubmit()">
      <header>
        <div class="grid-xp grid-cols-1 align-center">
          <h3 i18n>Kortingscode of Voucher inwisselen</h3>
        </div>
      </header>
      <fieldset formGroupName="voucher">
        <shared-form-input
          [styleClass]="'xperience'"
          [submitted]="submitted"
          [label]="LABEL_VOUCHER_CODE"
          [showLabel]="false"
          [formGroup]="formGroup"
          [control]="formGroup | getFormControl: 'voucher.code'">
        </shared-form-input>
      </fieldset>
      <footer>
        <div class="button-bar align-left">
          <shared-form-submit
            [buttonLabel]="LABEL_BUTTON_REDEEM"
            [buttonClass]="'is-colored'"
            [spinnerColorMode]="'light'"
            [showLabelOnSubmit]="false"
            [pristine]="formGroup.pristine"
            [submitting]="submitting()" />
        </div>
        <shared-error-messages [errorMessagesStore]="errorMessagesStore"></shared-error-messages>
      </footer>
    </form>
  </div>
</ng-container>
